import Hideout from "../Assets/tracks/hideout.wav";

export const Tracks = [{ name: "The Hideout - Gamerway10", track: Hideout }];
